module.exports = __webpack_public_path__ + "img/microplastics-process-4.6abb707b.png";